import axiosInstance from '@/plugins/axios';

// Perfis de Permissão — proxy BFF (roles.py) → tenant-provider → agnes-user-service.
// Paridade com o legado ServiceRoles do tax-tech-front-end (new_agnes).
export default class ServicePerfis {
  static listar = () => axiosInstance.get('roles');
  static buscar = (id) => axiosInstance.get(`roles/${id}`);
  static criar = (dados) => axiosInstance.post('roles', dados);
  static atualizar = (id, dados) => axiosInstance.patch(`roles/${id}`, dados);
  static excluir = (id) => axiosInstance.delete(`roles/${id}`);
  static atribuirPermissoes = (id, permissionIds) =>
    axiosInstance.put(`roles/${id}/permissions`, permissionIds);
  static historico = (id) => axiosInstance.get(`roles/${id}/history`);

  // Catálogo de permissões (~50/12 grupos) — endpoint novo no BFF (roles.py list_permissions).
  static listarPermissoes = (group) => {
    const params = group ? `?group=${encodeURIComponent(group)}` : '';
    return axiosInstance.get(`permissions${params}`);
  };
}
